import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SHOP_TRANSACTION_BY_ORDER_NUMBER_REQUEST = "API_SHOP_TRANSACTION_BY_ORDER_NUMBER_REQUEST";
export const API_SHOP_TRANSACTION_BY_ORDER_NUMBER_SUCCESS = "API_SHOP_TRANSACTION_BY_ORDER_NUMBER_SUCCESS";
export const API_SHOP_TRANSACTION_BY_ORDER_NUMBER_FAILURE = "API_SHOP_TRANSACTION_BY_ORDER_NUMBER_FAILURE";

export const api_shop_transaction_by_order_number_request = (options) => {
	return {
		type: API_SHOP_TRANSACTION_BY_ORDER_NUMBER_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_shop_transaction_by_order_number_success = (data) => {
	return {
		type: API_SHOP_TRANSACTION_BY_ORDER_NUMBER_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_shop_transaction_by_order_number_failure = (error) => {
	return {
		type: API_SHOP_TRANSACTION_BY_ORDER_NUMBER_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	ShopTransaction.apiShopTransactionByOrderNumber
*/
export const apiShopTransactionByOrderNumber = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_shop_transaction_by_order_number_request(options));
			const url=getAPIUrl([
				{"url": "/api/shop/transaction/byOrderNumber/KB/${options.ORDER_NUMBER}", "parameters": ["ORDER_NUMBER"]},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_shop_transaction_by_order_number_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_shop_transaction_by_order_number_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
